import React from 'react';

/* Eén teken voor "dit geldt nog niet".

   Het staat achter een kenmerk in de inrichtingenlijst en in de statusbadge van
   een put die aan een nog niet ingegaan recht hangt. Dezelfde vorm op beide
   plekken, omdat het hetzelfde betekent: er is iets vastgelegd dat pas op een
   datum in de toekomst gaat gelden.

   Kleur volgt currentColor, zodat het klokje in een oranje badge meekleurt en
   los in een tabelcel zijn eigen kleur kan krijgen. */
export default function Klokje({ grootte = 14, titel, stijl }) {
  return (
    <svg
      width={grootte}
      height={grootte}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={titel ? undefined : true}
      role={titel ? 'img' : undefined}
      style={{ flex: 'none', verticalAlign: 'text-bottom', ...(stijl || {}) }}
    >
      {titel && <title>{titel}</title>}
      <circle cx="12" cy="12" r="9" />
      <polyline points="12 7 12 12 15 14" />
    </svg>
  );
}
